import { render, staticRenderFns } from "./PopupWhats.vue?vue&type=template&id=00eabdfa&scoped=true&"
import script from "./PopupWhats.vue?vue&type=script&async=true&lang=js&"
export * from "./PopupWhats.vue?vue&type=script&async=true&lang=js&"
import style0 from "./PopupWhats.vue?vue&type=style&index=0&id=00eabdfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eabdfa",
  null
  
)

export default component.exports